import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/shopping`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const shoppingApi = {
  async getBestSellerArtist(payload) {
    return apiCall({
      url: `${BASE_URL}/getUserPurchasesPaginated`,
      method: "POST",
      data: payload
    });
  }
};

export const urlMakePageFetcherShopping = {
  url: `${BASE_URL}/getUserPurchasesPaginated`,
  method: "POST"
};

export { withQuery };
